import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import * as Styled from "./image-select-container.style";
export var ImageSelectContainer = function (_a) {
    var children = _a.children;
    return _jsx(Styled.Options, { children: children });
};
